/**
 * @generated SignedSource<<9307ebe7472925173e6f9d97bed48cda>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type TalentFacebookPageQuery$variables = Record<PropertyKey, never>;
export type TalentFacebookPageQuery$data = {
  readonly facebookLoginEnabled: boolean;
  readonly viewer: {
    readonly facebookPages: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
    }>;
    readonly facebookPagesKnown: boolean;
    readonly id: string;
    readonly name: string | null | undefined;
    readonly talentProfile: {
      readonly facebookPageName: string | null | undefined;
      readonly facebookPageUrl: string | null | undefined;
      readonly facebookPageVerified: boolean;
      readonly facebookProfileUrl: string | null | undefined;
      readonly id: string;
      readonly name: string;
    } | null | undefined;
  } | null | undefined;
};
export type TalentFacebookPageQuery = {
  response: TalentFacebookPageQuery$data;
  variables: TalentFacebookPageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "User",
    "kind": "LinkedField",
    "name": "viewer",
    "plural": false,
    "selections": [
      (v0/*: any*/),
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "facebookPagesKnown",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "FacebookPage",
        "kind": "LinkedField",
        "name": "facebookPages",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "TalentProfile",
        "kind": "LinkedField",
        "name": "talentProfile",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookProfileUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookPageUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookPageName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "facebookPageVerified",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "facebookLoginEnabled",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TalentFacebookPageQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "TalentFacebookPageQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "a06ef06473fa34d67bbeacf3413bb814",
    "id": null,
    "metadata": {},
    "name": "TalentFacebookPageQuery",
    "operationKind": "query",
    "text": "query TalentFacebookPageQuery {\n  viewer {\n    id\n    name\n    facebookPagesKnown\n    facebookPages {\n      id\n      name\n    }\n    talentProfile {\n      id\n      name\n      facebookProfileUrl\n      facebookPageUrl\n      facebookPageName\n      facebookPageVerified\n    }\n  }\n  facebookLoginEnabled\n}\n"
  }
};
})();

(node as any).hash = "fcba91292672fc822250f2addd0affa7";

export default node;
